import { Serializable } from "@/core/api/decorators/serializable_decorator"

@Serializable
export class RFQExtended {
  constructor(init?: Partial<RFQExtended>) {
    Object.assign(this, init)
  }
}
